import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Download } from "lucide-react";
import ThemeToggle from "@/components/ThemeToggle";
import { trackEvent } from "@/lib/analytics";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const links = [
    { label: "Services", href: "#services" },
    { label: "Approach", href: "#approach" },
    { label: "Case Studies", href: "#case-studies" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 w-full z-50 bg-white dark:bg-slate-950/80 backdrop-blur-xl border-b border-slate-200 dark:border-slate-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2">
          <img src="/leadtech-icon.png" alt="LeadTech Connect" className="h-8 w-auto" />
          <span className="font-heading font-bold tracking-tight text-slate-900 dark:text-white hidden sm:inline">
            LeadTech<span className="text-[#0891B2]">.</span>Connect
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm text-slate-600 dark:text-slate-400 hover:text-slate-900 transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://customer-assets.emergentagent.com/job_growth-engine-lab-5/artifacts/1knboaka_LeadTech%20Connect_Media%20Kit%20%281%29.pdf"
            download="LeadTech-Connect-Media-Kit.pdf"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("media_kit_download", { placement: "navbar" })}
            data-testid="nav-media-kit"
            className="inline-flex items-center gap-1.5 text-sm text-slate-700 dark:text-slate-300 hover:text-slate-900 border border-slate-300 dark:border-slate-700 hover:border-slate-900 px-3 py-1.5 transition-colors"
          >
            <Download size={13} /> Media Kit
          </a>
          <ThemeToggle />
          <a
            href="#contact"
            data-testid="nav-cta"
            className="text-sm bg-[#007AFF] hover:bg-[#0056d3] text-white px-4 py-2 shadow-[0_4px_20px_rgba(0,122,255,0.25)] hover:shadow-[0_6px_28px_rgba(0,122,255,0.4)] transition-colors"
          >
            Book Consultation
          </a>
        </nav>

        <div className="md:hidden flex items-center gap-2">
          <ThemeToggle />
          <button
            data-testid="mobile-menu-toggle"
            className="text-slate-900 dark:text-white p-2"
            onClick={() => setOpen((s) => !s)}
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="text-slate-700 dark:text-slate-300 text-sm"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="bg-[#007AFF] text-white px-4 py-2 text-sm text-center"
            >
              Book Consultation
            </a>
            <a
              href="https://customer-assets.emergentagent.com/job_growth-engine-lab-5/artifacts/1knboaka_LeadTech%20Connect_Media%20Kit%20%281%29.pdf"
              download="LeadTech-Connect-Media-Kit.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-media-kit"
              className="inline-flex items-center justify-center gap-2 border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-300 px-4 py-2 text-sm"
            >
              <Download size={13} /> Download Media Kit
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
